import React from 'react';

// Category Button Component - Text-only on mobile, icon + text on desktop
const CategoryButton = ({ categoryName, isSelected, onClick, displayName, isCompulsory, icon }) => (
  <button
    className={`category-button-horizontal ${
      isSelected ? 'category-button-selected' : 'category-button-default'
    }`}
    onClick={() => onClick(categoryName)}
    style={{ fontWeight: 700, textTransform: 'uppercase' }}
  >
    {/* Icon - desktop only */}
    {icon && (
      <span className="hidden lg:block category-button-icon">
        {icon}
      </span>
    )}
    <span className="category-button-text">
      {displayName || categoryName}
      {isCompulsory && <span className="ml-1 text-red-500">*</span>}
    </span>
  </button>
);

export default CategoryButton;